import { regExp } from '@sigma-frontend-libs/commons'

import { components, inputModes } from '@/utils'

export default function(h) {
  return h(
    components['text-field'],
    {
      props: {
        value: this.proxy,
        label: this.getTranslate(`${this.service}.labels.name`),
        disabled: this.disabled,
        mode: inputModes['line-label'],
        dense: true,
        rounded: true,
        required: true,
        autofocus: this.isNew,
        details: false,
        mask: regExp.otpSettingsTitle
      },
      on: {
        input: event => {
          this.proxy = event
        }
      }
    }
  )
}
